// extracted by mini-css-extract-plugin
module.exports = {"root":"intro_root__KZ68R","outer":"intro_outer__2TOEe","inner":"intro_inner__3sLXJ","heading":"intro_heading__2UkMw","description":"intro_description__MK1co"};